import sessionReplayImg from 'common/assets/images/tour-images/session-replay-tour.png';
import {LOCALES, Translatable} from 'common/i18n';
import {FeatureGateTier} from 'common/report/constants';
import {promptFeedbackModal} from 'common/widgets/feedback-modal';
import {FeedbackForFeature} from 'common/widgets/feedback-modal/types';

export interface TourData {
  title: Translatable;
  description: Translatable;
  tourImage?: string;
  secondaryDescription?: Translatable;
  primaryButtonText?: Translatable;
  primaryButtonLink?: string;
  secondaryButtonText?: Translatable;
  secondaryButtonLink?: string;
  expirationDate?: Date;
  featureGateTier?: string[];
  maxWidth?: string;
  displayDismissButton?: boolean;
  onClickPrimaryButton?: () => void;
}

export const TOURS = {
  'consistent-colors': {
    maxWidth: `300px`,
    secondaryButtonLink: `https://docs.mixpanel.com/docs/features/chart-customization#segment-coloring`,
    title: ({t}) => t(`tours.consistent-colors.title`),
    description: ({t}) => t(`tours.consistent-colors.description`),
    primaryButtonText: ({t}) => t(`tours.consistent-colors.cta`),
    secondaryButtonText: ({t}) => t(`tours.cta-docs`),
  },
  sessionReplayFreeTour: {
    title: ({t}) => t(`tours.session-replay.title`),
    description: ({t}) => t(`tours.session-replay.description-free`),
    tourImage: sessionReplayImg,
    secondaryDescription: ({t}) => t(`tours.session-replay.description-2`),
    primaryButtonText: ({t}) => t(`common.learn-more`),
    primaryButtonLink: `https://mixpanel.com/releases/session-replay/`,
    secondaryButtonText: ({t}) => t(`tours.cta-docs`),
    secondaryButtonLink: `https://docs.mixpanel.com/docs/session-replay/session-replay-web`,
    expirationDate: new Date(`2024-12-15T23:59:59Z`),
    featureGateTier: [FeatureGateTier.Free, FeatureGateTier.Business],
    displayDismissButton: true,
  },
  localization: {
    title: ({t}) => t(`tours.localization.title`),
    description: ({t, language}) =>
      t(`tours.localization.description`, {
        currentLanguage: LOCALES.find((locale) => locale.code === language)?.displayName,
      }),
    primaryButtonText: ({t}) => t(`help.submit-feedback`),
    onClickPrimaryButton: () =>
      promptFeedbackModal({
        feature: FeedbackForFeature.Localization,
      }),
    displayDismissButton: true,
  },
} as const satisfies Record<string, TourData>;

export type TourName = keyof typeof TOURS;
